import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService {
    setItem(key: string, value: any): void {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.error('Error saving to local storage', error);
        }
    }

    getItem<T>(key: string): T | null {
        try {
            const raw = localStorage.getItem(key);
            if (raw === null) return null;
            try {
                return JSON.parse(raw);
            } catch {
                return raw as unknown as T;
            }
        } catch (error) {
            console.error('Error reading from local storage', error);
            return null;
        }
    }

    removeItem(key: string): void {
        localStorage.removeItem(key);
    }

    clear(): void {
        localStorage.clear();
    }
}
